import React, { Component } from 'react'

import {
  RadioGroup,
  Icon,
  ButtonAction,
  Select,
  Tooltip,
  FormGroup,
  Input
} from "xsolla-uikit";


import { PAInputPricesPrice } from "./PAInputPricesPrice";


// import { KeyContext } from "../App";



export default class PAInputPrices extends Component {

  constructor(props) {
    super(props)
    this.currLocked = props.currLocked || false;
    this.add = props.add || false;

    this.state = {
      curr: props.curr || "usd",
      platform: props.platform || "All platforms",
      price: props.price || "0",
    }
  }




  render() {
    return (
      <React.Fragment>
        <FormGroup indentation="sm">
          <div>
            <FormGroup label="" indentation="lg">
              <PAInputPricesPrice
                handeCurrDel={this.props.handeCurrDel}
                priceId={this.props.id}
                sku={this.props.sku}
                currLocked={this.currLocked}
              />
            </FormGroup>
          </div>
        </FormGroup>
      </React.Fragment>
    );
  }
}
